import Media from "./media";

export class EndorsementContentMedia {
  id: number;
  media: Media;
  fromJson(data): EndorsementContentMedia {
    this.id = data.id;
    if (data.media) {
      this.media = new Media().fromJson(data.media);
    }
    return this;
  }
}

export class EndorsementContentYouTube {
  id: number;
  video_id: string;
  fromJson(data): EndorsementContentYouTube {
    this.id = data.id;
    this.video_id = data.video_id;
    return this;
  }
}

export class EndorsementContentIFrame {
  id: number;
  url: string;
  fromJson(data): EndorsementContentIFrame {
    this.id = data.id;
    this.url = data.url;
    return this;
  }
}

class Endorsement {
  id: number;
  title: string;
  created_at: Date;
  updated_at: Date;
  summary: string;
  content_items: Array<
    | EndorsementContentMedia
    | EndorsementContentYouTube
    | EndorsementContentIFrame
  >;

  fromJson(data): Endorsement {
    this.id = data.id;
    this.title = data.title;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.summary = data.summary;
    if (data.content_items) {
      this.content_items = data.content_items.map((c) => {
        if (c.__component == "endorsement.media") {
          return new EndorsementContentMedia().fromJson(c);
        }
        if (c.__component == "endorsement.youtube") {
          return new EndorsementContentYouTube().fromJson(c);
        }
        if (c.__component == "endorsement.iframe") {
          return new EndorsementContentIFrame().fromJson(c);
        }
      });
    }
    return this;
  }
}

export default Endorsement;
